var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "input_number__container",
      class: { disabled: _vm.disabled },
    },
    [
      _c("span", {
        staticClass: "up-arrow",
        on: {
          click: function ($event) {
            !_vm.disabled ? _vm.update("increment") : null
          },
        },
      }),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.inputVal,
            expression: "inputVal",
          },
        ],
        staticClass: "form-control input_number",
        attrs: {
          type: "number",
          placeholder: _vm.placeholder,
          max: _vm.max,
          min: _vm.min,
          disabled: _vm.disabled,
        },
        domProps: { value: _vm.inputVal },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) return
              _vm.inputVal = $event.target.value
            },
            _vm.handleClick,
          ],
        },
      }),
      _c("span", {
        staticClass: "down-arrow",
        on: {
          click: function ($event) {
            !_vm.disabled ? _vm.update("decrement") : null
          },
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }